import schoolConstants from '../constants/schoolConstants';
import { CognitoUserPool } from 'amazon-cognito-identity-js';

export default function () {
  return new Promise((resolve, reject) => {
    var params = {
      UserPoolId: schoolConstants[localStorage.zmailSchoolName].UserPoolId,
      ClientId: schoolConstants[localStorage.zmailSchoolName].ClientId,
    };
    var userPool = new CognitoUserPool(params);
    var cognitoUser = userPool.getCurrentUser();

    if (cognitoUser == null) reject(new Error('no user found'));
    else {
      cognitoUser.signOut();
      resolve();
    }
  });
}



// WEBPACK FOOTER //
// ./src/authentication/logout.js